import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import { APP_DEFAULT_PATH } from '../../config';
import { useUserContext } from '../../contexts/UserContext';

// ==============================|| GUEST GUARD ||============================== //

export default function GuestGuard({ children }) {
  const { isLoggedIn } = useUserContext();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      // Only navigate if already on a guest page like /login
      const isOnGuestPage = location.pathname === '/' || location.pathname === '/auth/login';
      if (isOnGuestPage) {
        navigate(location?.state?.from || APP_DEFAULT_PATH, { replace: true });
      }
    }
  }, [isLoggedIn, location.pathname, navigate]);

  return children;
}

GuestGuard.propTypes = { children: PropTypes.any };
